import { faMoneyCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useRef } from 'react';
import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import apiMethods from '../../constants/apiMethods';
import colors from '../../constants/colors';

import routes from '../../constants/routes';
import alertMessages from '../../helpers/alertMessages';
import api from '../../helpers/api';
import es from '../../lang/es';
import PaymentRow from '../Payments/PaymentRow';

const OnlineForm = props => {
    //Tomo los props
    const { paymentData } = props;
    //Ref
    const formRef = useRef();
    //Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        //Confirmación
        const data = {
            title: es.CONFIRMATION.ONLINE_PAYMENT,
            text: 'Está a punto de ser redirigido a la plataforma de Pagos Online',
            confirmText: es.PAYMENTS.ONLINE.toUpperCase(),
            confirmColor: colors.green,
            callback: async () => {
                //Muestro espera
                alertMessages.waiting(es.LOADINGS.PROCESSING);
                //Tomo el id del pago
                const paymentId = paymentData.paymentLot.id;
                //Actualizo el pago
                try{
                    await api.post(apiMethods.CHECKOUT_ONLINE_SUCCESS(paymentId));
                    //Una vez completado, submit del form
                    formRef.current.submit();
                }catch(error){
                    //Tomo respuesta
                    const errorResponse = error.response;
                    //Inicializo
                    let errorData = {
                        data: null,
                        message: es.ERRORS.SERVER_CONN
                    };
                    //Verifico si hay error
                    if(errorResponse){
                        errorData = errorResponse.data;
                    }
                    //Muestro mensaje
                    alertMessages.error(errorData.message);
                }
            }
        }
        //Muestro confirmación
        alertMessages.confirm(data);
    }
    //Render
    return (
        <Form 
            action={process.env.REACT_APP_URL_ONLINE_PAYMENT} 
            method="post" 
            className="col"
            onSubmit={handleSubmit}
            ref={formRef}
        >
            <Row>
                <input type="hidden" name="CallbackSuccess" value={ paymentData.ppData.callbackSuccess} />
                <input type="hidden" name="CallbackCancel" value={ paymentData.ppData.cancelEncriptada } />
                <input type="hidden" name="Comercio" value={ paymentData.ppData.comercio } />
                <input type="hidden" name="SucursalComercio" value={ paymentData.ppData.sucursal } />
                <input type="hidden" name="Hash" value={ paymentData.ppData.hash } />
                <input type="hidden" name="TransaccionComercioId" value={ paymentData.paymentLot.identificator_online } />
                <input type="hidden" name="Monto" value={ paymentData.ppData.amount } />
                <input type="hidden" name="ClientData.CUIT" value={paymentData.paymentLot.cuit} />
                <input type="hidden" name="ClientData.NombreApellido" value={paymentData.paymentLot.full_name} />

                <Col xs={12}>
                    <Card>
                        <Card.Header className='bg-dark'>
                            <strong className='ml-2 text-white'>{ paymentData.paymentLot.identificator }</strong>
                        </Card.Header>
                        <Table hover bordered size="sm" responsive className='d-none d-md-table'>
                            <thead className="thead-light">
                                <tr>
                                    <th>{ es.FIELDS.DATE }</th>
                                    <th>{ es.FIELDS.PROCEEDING }</th>
                                    <th>{ es.FIELDS.TYPE }</th>
                                    <th>{ es.FIELDS.AMOUNT }</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    paymentData.paymentLot.payments.map((payment, index) => (
                                        <>
                                            <input type="hidden" name={`Producto[${ index }]`} value={`${payment.number}: ${payment.type.description}` } />
                                            <PaymentRow
                                                key={`payment-row-${payment.id}`}
                                                payment={payment}
                                                isMobile={false}
                                                isForm={true}
                                            />
                                        </>
                                    ))
                                }
                            </tbody>
                            <tfoot className="table-primary">
                                <tr>
                                    <td colSpan="3" className="text-right">
                                        <h5 className='mb-0'><strong>{ es.FIELDS.TOTAL }</strong></h5>
                                    </td>
                                    <td className="align-middle text-right">
                                        <h5 className='mb-0'><strong>{ es.PAYMENTS.CURRENCY } { paymentData.paymentLot.total }</strong></h5>
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                        <ul className="list-group list-group-flush d-md-none">
                            {
                                paymentData.paymentLot.payments.map( payment => (
                                    <PaymentRow
                                        key={`payment-row-${payment.id}`}
                                        payment={payment}
                                        isMobile={true}
                                        isForm={true}
                                    />
                                ))
                            }
                        </ul>
                        <Card.Footer>
                            <Row>
                                <Col md={6} xs={12} className='text-center text-md-left mb-3 mb-md-0'>
                                    <span className="h4">
                                        { es.PAYMENTS.TOTAL.toUpperCase() }: { es.PAYMENTS.CURRENCY }<strong>{ paymentData.paymentLot.total }</strong>
                                    </span>
                                </Col>
                                <Col md={6} xs={12} className='text-center text-md-right'>
                                    <Button variant="success" className="mr-2" type="submit" size="sm">
                                        <FontAwesomeIcon icon={faMoneyCheck} /> <strong>{ es.ACTIONS.PAID_OUT.toUpperCase() }</strong>
                                    </Button>
                                    <Link className="btn btn-danger btn-sm" to={ routes.PAYMENT_CHECKOUT }>
                                        <FontAwesomeIcon icon={faTimes} /> <strong>{ es.CANCEL.toUpperCase() }</strong>
                                    </Link>
                                </Col>
                            </Row>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Form>
    );
};

export default OnlineForm;